'use strict';

var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var swal = _interopDefault(require('sweetalert'));

var index =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var newOptions,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getOptions.apply(void 0, _args);

          case 2:
            newOptions = _context.sent;
            return _context.abrupt("return", swal(newOptions));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function index() {
    return _ref.apply(this, arguments);
  };
}();

var bindActions = function bindActions(swalInstance) {
  for (var method in swal) {
    swalInstance[method] = swal[method];
  }
};

var getOptions =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(params, _ref2) {
    var identifier, transformer, newOptions, lastParam;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            identifier = _ref2.identifier, transformer = _ref2.transformer;
            _context2.next = 3;
            return transformParams(params, identifier, transformer);

          case 3:
            newOptions = _context2.sent;
            newOptions = Object.assign({}, parseTextParams(params), newOptions);
            lastParam = params[params.length - 1];
            /*
             * So that we don't lose other specified options
             * such as buttons... etc.
             */

            if (isOptionsParam(lastParam, identifier)) {
              newOptions = Object.assign({}, lastParam, newOptions);
            }

            return _context2.abrupt("return", newOptions);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getOptions(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

var parseTextParams = function parseTextParams(params) {
  var options = {};

  var isString = function isString(param) {
    return typeof param === "string";
  };

  if (isString(params[0]) && !isString(params[1])) {
    options.text = params[0];
  }

  if (isString(params[1])) {
    options.title = params[0];
    options.text = params[1];
  }

  if (isString(params[2])) {
    options.icon = params[2];
  }

  return options;
}; // Return true if param is a SwalOptions object


var isOptionsParam = function isOptionsParam(param, isTransformable) {
  return param.constructor === Object && !isTransformable(param);
};
/*
 * @params: (SwalParams, Function, Function, boolean)
 * @returns: SwalOptions
 */


var transformParams =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(params, isTransformable, transformer) {
    var isAsync, transformSingleParam, transformContentOption, newOpts;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            // Check if the transform returns a DOM synchronously
            // or if it is a promise:
            isAsync = transformer() instanceof Promise;
            /*
             * Example:
             *   swal(<div>Hello!</div>);
             */

            transformSingleParam =
            /*#__PURE__*/
            function () {
              var _ref5 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3() {
                var el, newContent;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        el = params[0];

                        if (isTransformable(el)) {
                          _context3.next = 3;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 3:
                        _context3.next = 5;
                        return transformEl(el, transformer, isAsync);

                      case 5:
                        newContent = _context3.sent;
                        return _context3.abrupt("return", {
                          content: newContent
                        });

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function transformSingleParam() {
                return _ref5.apply(this, arguments);
              };
            }();
            /*
             * Example:
             *   swal("Hi", { 
             *     content: <div>Hello!</div> 
             *   })
             */


            transformContentOption =
            /*#__PURE__*/
            function () {
              var _ref6 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee4() {
                var lastParamIndex, lastParam, content, button;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        lastParamIndex = params.length - 1;
                        lastParam = params[lastParamIndex];

                        if (!(!lastParam || !lastParam.content)) {
                          _context4.next = 4;
                          break;
                        }

                        return _context4.abrupt("return");

                      case 4:
                        content = lastParam.content, button = lastParam.button;

                        if (!isTransformable(content)) {
                          _context4.next = 9;
                          break;
                        }

                        _context4.next = 8;
                        return transformEl(content, transformer, isAsync);

                      case 8:
                        content = _context4.sent;

                      case 9:
                        return _context4.abrupt("return", {
                          content: content //button,

                        });

                      case 10:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function transformContentOption() {
                return _ref6.apply(this, arguments);
              };
            }();
            /*
             * Only transform the params that can 
             * have a DOM node as their value
             */


            _context5.next = 5;
            return Promise.all([transformSingleParam(), transformContentOption()]);

          case 5:
            newOpts = _context5.sent;
            return _context5.abrupt("return", Object.assign.apply(Object, [{}].concat(_toConsumableArray(newOpts))));

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function transformParams(_x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}(); // Transform a single option


var transformEl =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(el, transformer, isAsync) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!isAsync) {
              _context6.next = 6;
              break;
            }

            _context6.next = 3;
            return transformer(el);

          case 3:
            _context6.t0 = _context6.sent;
            _context6.next = 7;
            break;

          case 6:
            _context6.t0 = transformer(el);

          case 7:
            return _context6.abrupt("return", _context6.t0);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function transformEl(_x6, _x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();

exports['default'] = index;
exports.bindActions = bindActions;